/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ProductEditor from './product-editor';

const SubProductsEditor = ({ products, beforeProductSwitches, onComplete }) => {
    const [view_index, setViewIndex] = useState(0);
    const product = products[view_index];
    const is_final_product = view_index === products.length - 1;
    const { t } = useTranslation('product-editor');
    let product_editor;

    const onDoneButtonClick = () => {
        const unmet_selection_requirement = product.getUnmetSelectionRequirementModifierGroup();
        if (unmet_selection_requirement) {
            product_editor.groupSelectionRequirementWarning(
                unmet_selection_requirement
            );
            return;
        }

        if (is_final_product) {
            onComplete();
            return;
        }

        const switchProduct = () => setViewIndex(view_index + 1);
        beforeProductSwitches().then(switchProduct);
    };

    return (
        <>
            <ProductEditor
                closeModal={onComplete}
                product={product}
                scrollModalElementIntoView={() => {}}
                ref={component => {
                    product_editor = component;
                }}
                footerElementOverride={
                    <div className="m2g-product-editor-sub-product-footer">
                        {products.length > 1 && (
                            <div className="m2g-product-editor-sub-product-footer-progress">
                                {view_index + 1}/{products.length}
                            </div>
                        )}
                        <button
                            className="m2g-product-editor-sub-product-footer-button m2g-button m2g-button--primary"
                            type="button"
                            tabIndex="0"
                            onKeyUp={() => {}}
                            onClick={onDoneButtonClick}
                        >
                            {is_final_product ? t('done') : t('next')}
                        </button>
                    </div>
                }
            />
        </>
    );
};

SubProductsEditor.propTypes = {
    products: PropTypes.array.isRequired,
    onComplete: PropTypes.func.isRequired,
    beforeProductSwitches: PropTypes.func.isRequired,
};

export default SubProductsEditor;
